import { StudentStatusTypeEnum } from "../../constants";

export function getStudentLoginStatusType(status:StudentStatusTypeEnum) {
 switch (status) {
   case StudentStatusTypeEnum.ACTIVE: return "Giriş Yapıldı"
   case StudentStatusTypeEnum.APPROVE_WAITING: return "Onay bekleniyor";
   case StudentStatusTypeEnum.LOGIN_WAITING: return "Giriş bekleniyor";
   case StudentStatusTypeEnum.DELETED:return "Kaldırıldı";
   case StudentStatusTypeEnum.NOT_APPROVED: return "Onaylanmadı";
   default: return "Kontrol gerekiyor";
 }
}
export function getStudentStatusType(status:StudentStatusTypeEnum) {
  switch (status) {
    case StudentStatusTypeEnum.ACTIVE: return "Onaylandı"
    case StudentStatusTypeEnum.APPROVE_WAITING: return "Onay bekleniyor";
    case StudentStatusTypeEnum.LOGIN_WAITING: return "Giriş bekleniyor";
    case StudentStatusTypeEnum.DELETED:return "Kaldırıldı";
    case StudentStatusTypeEnum.NOT_APPROVED: return "Onaylanmadı";
    default: return "Kontrol gerekiyor";
  }
}